import { styled } from "@mui/material";
import { TextFieldCustom } from "components";
import useDatePickerState from "./_common/useDatePickerState";
import CalendarIconAdornment from "./_common/CalendarIconAdornment";
import CommonDayPicker from "./_common/CommonDayPicker";

const DayPickerCamvioUnstyled = ({
  availableDates,
  className,
  defaultValue,
  formatDisplay = "DD/MM/YYYY",
  formatValue,
  helperText,
  iconSize,
  isError,
  isLoading,
  isDisabled,
  isFullWidth,
  isViewMode,
  label,
  maxDate,
  minDate,
  name,
  onChange,
  onMonthChange,
  placeholder,
  showYears,
  value,
}) => {
  const {
    innerValue,
    displayedText,
    defaultMonth,
    isOpen,
    anchorEl,
    handleOpen,
    handleClose,
    handleChange,
    disableDate,
  } = useDatePickerState({
    value,
    isDisabled,
    isViewMode,
    isLoading,
    defaultValue,
    formatDisplay,
    formatValue,
    availableDates,
    onChange,
  });

  return (
    <>
      <TextFieldCustom
        name={name}
        label={label}
        value={displayedText}
        placeholder={placeholder}
        helperText={helperText}
        isReadOnly
        isLoading={isLoading}
        isFullWidth={isFullWidth}
        isViewMode={isViewMode}
        isDisabled={isDisabled}
        isError={isError}
        slotProps={{
          input: {
            endAdornment: <CalendarIconAdornment iconSize={iconSize} />,
          },
        }}
        className={className}
        onClick={handleOpen}
      />
      <CommonDayPicker
        value={value}
        innerValue={innerValue}
        variant="single"
        isOpen={isOpen}
        anchorEl={anchorEl}
        disableDate={disableDate}
        defaultMonth={defaultMonth}
        minDate={minDate}
        maxDate={maxDate}
        showYears={showYears}
        onClose={handleClose}
        onChange={handleChange}
        onMonthChange={onMonthChange}
      />
    </>
  );
};

const DayPickerCamvio = styled(DayPickerCamvioUnstyled)({});

export default DayPickerCamvio;
